module.exports = __webpack_public_path__ + "img/logo.58411dc5.svg";